import { TaxEstimateRequest, TaxEstimateResponse } from '../common/models/TaxEstimate';
import { MembershipUpgradeResponse } from '../common/models/StripePayment';
import { axiosInstance } from './apiConfig';

export interface SNUpgradePayload {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  zip: string;
  billingFrequency: 'monthly' | 'annual';
  stripePaymentMethodId: string;
  promoCode?: string;
  totalAmount: number;
}

export interface SnMembershipCheckResponse {
  success: boolean;
  statusCode: number;
  data: {
    has_active_account: boolean;
    is_sn_native?: boolean;
    membership_level?: string;
    // Only included by SN when the user has an active account. The frontend
    // (getMemberInformation) only reads these for is_sn_native members, since
    // non-native SN accounts don't carry this master/sub-account data model.
    is_master_account?: boolean;
    my_purchases_access?: boolean;
    historic_rebate_access?: boolean;
  };
}

export const getTaxEstimate = async (
  params: TaxEstimateRequest,
): Promise<TaxEstimateResponse> => {
  const { data } = await axiosInstance.get<TaxEstimateResponse>(
    '/membership/upgrade/tax-estimate',
    { params },
  );
  return data;
};

export const upgradeMembership = async (
  payload: SNUpgradePayload,
): Promise<MembershipUpgradeResponse> => {
  const { data } = await axiosInstance.post<MembershipUpgradeResponse>(
    '/membership/upgrade',
    payload,
  );
  return data;
};

export const getSnMembershipForSNNative = async (
  email: string,
): Promise<SnMembershipCheckResponse> => {
  const { data } = await axiosInstance.post<SnMembershipCheckResponse>(
    '/membership/check',
    { email },
  );
  return data;
};
